/* Sale strip countdown. Only runs when a real end date is set on the section. */
(function () {
  var pad = function (n) { return n < 10 ? '0' + n : '' + n; };

  function tick() {
    var strips = document.querySelectorAll('[data-sale-ends]');
    if (!strips.length) return false;
    var live = false;

    for (var i = 0; i < strips.length; i++) {
      var el = strips[i];
      var out = el.querySelector('[data-sale-count]');
      var rule = el.querySelector('[data-sale-rule]');
      if (!out) continue;

      var raw = el.getAttribute('data-sale-ends');
      var end = Date.parse(raw);
      if (isNaN(end)) { end = Date.parse(raw.replace(' ', 'T')); }
      if (isNaN(end)) { out.hidden = true; if (rule) rule.hidden = true; continue; }

      var ms = end - Date.now();
      if (ms <= 0) { out.hidden = true; if (rule) rule.hidden = true; continue; }

      var d = Math.floor(ms / 86400000);
      var h = Math.floor((ms % 86400000) / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      var s = Math.floor((ms % 60000) / 1000);

      out.textContent = (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s) + ' left';
      out.hidden = false;
      if (rule) rule.hidden = false;
      live = true;
    }
    return live;
  }

  function start() { tick(); setInterval(tick, 1000); }
  if (document.readyState === 'loading') { document.addEventListener('DOMContentLoaded', start); } else { start(); }
})();
